import { useNavigate } from 'react-router-dom';

import NavigationButton from './NavigationButton';

import IMAGE_LEADERBOARD from './leaderboard.png';
import IMAGE_ADDKM from './addkm.png';
import IMAGE_MYACTIVITY from './myactivity.png';

const NAVITEMS = [
    {
        label: "Leaderboards",
        path: "/",
        img: IMAGE_LEADERBOARD
    },
    {
        label: "Add km",
        path: "/participant/secure/add",
        img: IMAGE_ADDKM
    },
    {
        label: "My activity",
        path: "/participant/secure/log",
        img: IMAGE_MYACTIVITY
    },
];


function Navigation () 
{
    const navigate = useNavigate ();

    return <> 
            <div className="flex flex-row justify-center gap-2">
                {
                    NAVITEMS.map ( item => <NavigationButton key={item.path} onClick={ () => navigate ( item.path ) } image={item.img} label={item.label} /> )
                }
            </div>
        </>
}

export default Navigation;
